import { render } from "./sku-detail.vue?vue&type=template&id=416951a9&scoped=true&ts=true"
import script from "./sku-detail.vue?vue&type=script&lang=ts"
export * from "./sku-detail.vue?vue&type=script&lang=ts"

import "./sku-detail.vue?vue&type=style&index=0&id=416951a9&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416951a9"]])

export default __exports__